import React from 'react';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import css from './RouteMoney.module.css';
import charityImg from '../enquiriesSectionImage.jpg';
import giftsImg from './gifts.avif';
import volunteerImg from './volunteer.avif';
import causeImg from './image.png';

// "Partner with Causee" — the charity-partnership band from the refreshed design
// mockup, rebuilt on the site's coffee/honey palette. Per the launch spec (Jira
// P25028-43 §12) it carries a single honey CTA, which links to the contact page
// (/p/contact -> CMSPage "contact"). The mockup's fabricated testimonial is
// intentionally left out; a 2x2 grid of four real photos is shown instead.
//
// The band used to invite charities *and* individuals. Launch copy narrows it to
// charities only, and the client confirmed individuals are not being invited
// elsewhere for now.

const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const BULLETS = [
  {
    leadId: 'CustomLandingPage.routeMoney.bullet.free.lead',
    textId: 'CustomLandingPage.routeMoney.bullet.free.text',
  },
  {
    leadId: 'CustomLandingPage.routeMoney.bullet.reach.lead',
    textId: 'CustomLandingPage.routeMoney.bullet.reach.text',
  },
  {
    leadId: 'CustomLandingPage.routeMoney.bullet.impact.lead',
    textId: 'CustomLandingPage.routeMoney.bullet.impact.text',
  },
];

const RouteMoney = () => {
  const intl = useIntl();

  return (
    <section className={css.section}>
      <div className={css.grid}>
        <div className={css.content}>
          <span className={css.eyebrow}>
            <FormattedMessage id="CustomLandingPage.routeMoney.eyebrow" />
          </span>
          <h2 className={css.heading}>
            <FormattedMessage
              id="CustomLandingPage.routeMoney.heading"
              values={{
                accent: (
                  <em>
                    <FormattedMessage id="CustomLandingPage.routeMoney.headingAccent" />
                  </em>
                ),
              }}
            />
          </h2>
          <p className={css.bodyLead}>
            <FormattedMessage id="CustomLandingPage.routeMoney.body1" />
          </p>
          <p className={css.body}>
            <FormattedMessage id="CustomLandingPage.routeMoney.body2" />
          </p>

          <ul className={css.bullets}>
            {BULLETS.map(b => (
              <li key={b.leadId}>
                <span className={css.bulletIcon} aria-hidden="true">
                  <CheckIcon />
                </span>
                <span>
                  <strong>
                    <FormattedMessage id={b.leadId} />
                  </strong>{' '}
                  <FormattedMessage id={b.textId} />
                </span>
              </li>
            ))}
          </ul>

          <NamedLink className={css.cta} name="CMSPage" params={{ pageId: 'contact' }}>
            <FormattedMessage id="CustomLandingPage.routeMoney.cta" />
          </NamedLink>
        </div>

        <div className={css.art}>
          <div className={css.photos}>
            <div className={css.photo}>
              <img
                src={charityImg}
                alt={intl.formatMessage({ id: 'CustomLandingPage.routeMoney.imageAlt.charity' })}
                loading="lazy"
              />
            </div>
            <div className={css.photo}>
              <img
                src={giftsImg}
                alt={intl.formatMessage({ id: 'CustomLandingPage.routeMoney.imageAlt.gifts' })}
                loading="lazy"
              />
            </div>
            <div className={css.photo}>
              <img
                src={volunteerImg}
                alt={intl.formatMessage({ id: 'CustomLandingPage.routeMoney.imageAlt.volunteer' })}
                loading="lazy"
              />
            </div>
            <div className={css.photo}>
              <img
                src={causeImg}
                alt={intl.formatMessage({ id: 'CustomLandingPage.routeMoney.imageAlt.cause' })}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RouteMoney;
